module.exports = __webpack_public_path__ + "img/icb-empty-Inte-e@3x.1a6ff659.png";